import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './StartJourney.css';

const initialForm = { name: '', currentWeight: '', targetWeight: '', height: '', age: '', mobileNumber: '' };

export default function StartJourney() {
  const { code } = useParams();
  const [invitation, setInvitation] = useState(null);
  const [form, setForm] = useState(initialForm);
  const [state, setState] = useState('loading');
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  useEffect(() => {
    let active = true;
    axios.get(`/api/referrals/public/${encodeURIComponent(code)}`)
      .then(({ data }) => {
        if (!active) return;
        setInvitation(data);
        setState(data.status === 'COMPLETED' ? 'used' : 'ready');
      })
      .catch(() => active && setState('invalid'));
    return () => { active = false; };
  }, [code]);

  const update = ({ target }) => setForm(current => ({ ...current, [target.name]: target.value }));
  const submit = async event => {
    event.preventDefault();
    setError('');
    setState('submitting');
    try {
      const { data } = await axios.post(`/api/referrals/public/${encodeURIComponent(code)}/submit`, {
        ...form,
        currentWeight: Number(form.currentWeight), targetWeight: Number(form.targetWeight),
        height: Number(form.height), age: Number(form.age)
      });
      setResult(data);
      setState('success');
    } catch (requestError) {
      if (requestError.response?.status === 409) setState('used');
      else {
        setError(requestError.response?.data?.message || 'We could not submit your details. Please check the form and try again.');
        setState('ready');
      }
    }
  };

  if (state === 'loading') return <JourneyShell><div className="journey-loader"/><p>Opening your invitation…</p></JourneyShell>;
  if (state === 'invalid') return <JourneyShell><h1>Invitation not found</h1><p>This referral link is invalid. Please ask your friend for a new link.</p></JourneyShell>;
  if (state === 'used') return <JourneyShell><div className="journey-status-icon">✓</div><h1>Invitation already accepted</h1><p>This referral has already been submitted. Please ask for a new link if you need another enquiry.</p></JourneyShell>;
  if (state === 'success') return <JourneyShell><div className="journey-success"><span>✓</span></div><p className="journey-kicker">YOU'RE ALL SET</p><h1>Thank you for taking the first step towards a healthy lifestyle!</h1><p>Coach <strong>{result.coachName}</strong> will contact you soon.</p></JourneyShell>;

  const invitationLabel = invitation.invitationType === 'CLUB_TRIAL' ? 'Club Trial' : 'Online Program';
  return <JourneyShell>
    <p className="journey-kicker">{invitationLabel}</p>
    <h1>Start your healthy journey</h1>
    <p>Thanks for accepting an invitation from <strong>{invitation.referrerName}</strong>. Tell Coach <strong>{invitation.coachName}</strong> a little about your goal.</p>
    <form className="journey-form" onSubmit={submit}>
      <Field label="Your name" name="name" value={form.name} onChange={update} placeholder="Full name" autoComplete="name" />
      <div className="journey-row">
        <Field label="Current weight (kg)" name="currentWeight" value={form.currentWeight} onChange={update} type="number" min="20" max="400" step="0.1" />
        <Field label="Target weight (kg)" name="targetWeight" value={form.targetWeight} onChange={update} type="number" min="20" max="400" step="0.1" />
      </div>
      <div className="journey-row">
        <Field label="Height (cm)" name="height" value={form.height} onChange={update} type="number" min="80" max="250" step="0.1" />
        <Field label="Age" name="age" value={form.age} onChange={update} type="number" min="12" max="100" step="1" />
      </div>
      <Field label="Mobile number" name="mobileNumber" value={form.mobileNumber} onChange={update} type="tel" placeholder="e.g. +91 98765 43210" autoComplete="tel" pattern="[+0-9][0-9 -]{7,18}" />
      {error && <div className="journey-error" role="alert">{error}</div>}
      <button disabled={state === 'submitting'} type="submit">{state === 'submitting' ? 'Submitting…' : 'Take the first step'}<span>→</span></button>
      <small>Your details will only be shared with the coach named above.</small>
    </form>
  </JourneyShell>;
}

function Field({ label, ...props }) {
  return <label className="journey-field"><span>{label}</span><input required {...props}/></label>;
}

function JourneyShell({ children }) {
  return <div className="journey-page"><div className="journey-orb journey-orb-one"/><div className="journey-orb journey-orb-two"/><main className="journey-card"><div className="journey-leaf">♥</div>{children}</main></div>;
}
